export { default } from './FullSizeLoading';
export { default as FullSizeLoading } from './FullSizeLoading';
